import { Reveal } from "@/components/Reveal";
import { Professionals as ProfessionalsData } from "@/data/SiteContent";

export default function Professionals() {
  return (
    <section id="profesionales" className="scroll-mt-20 bg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-dark">
            Nuestro equipo
          </p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            Profesionales a su servicio
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ash">
            Un equipo comprometido con brindar asesoría legal y notarial profesional, confiable y
            personalizada.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {ProfessionalsData.map((pProfessional, pIndex) => (
            <Reveal key={pProfessional.Id} Delay={pIndex * 120} className="h-full">
              <article
                data-testid={`professional-card-${pProfessional.Id}`}
                className="flex h-full flex-col border border-ink/10 bg-white px-8 py-10 text-center transition-shadow duration-300 hover:shadow-md"
              >
                <div
                  className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-gold/60 font-serif text-2xl text-gold-dark"
                  aria-hidden="true"
                >
                  {pProfessional.Initials}
                </div>
                <h3 className="mt-6 font-serif text-xl leading-snug text-ink">
                  {pProfessional.Name}
                </h3>
                <p className="mt-2 text-xs font-medium uppercase tracking-[0.2em] text-gold-dark">
                  {pProfessional.Role}
                </p>
                <div className="mx-auto mt-5 h-px w-10 bg-gold/50" aria-hidden="true" />
                <p className="mt-5 text-sm leading-relaxed text-ash">{pProfessional.Profile}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
